"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../utils/common");

var _common2 = _interopRequireDefault(_common);

var _store = require("linksoft/core/store");

var _store2 = _interopRequireDefault(_store);

var _storageProvider = require("../storageProvider");

var _storageProvider2 = _interopRequireDefault(_storageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacetPopupFilter = function () {
    function FacetPopupFilter(showHideDialog) {
        (0, _classCallCheck3.default)(this, FacetPopupFilter);

        this.showHideDialog = showHideDialog;
        this.currentFacetGroup = null;
        this.filteringLetter = null;
        this.facetGroupName = null;
        this.hideFilteringHeader = null;
        this.filterString = null;
        this.selectedItems = {};
        this.maxFilterItemsLimit = window.maxFilterItemsLimit || 40;
        this.loadAuthors();
    }

    (0, _createClass3.default)(FacetPopupFilter, [{
        key: "setupFacetGroup",
        value: function setupFacetGroup(currentButton, setFacetGroupCallback) {
            var _this = this;

            this.facetGroupName = currentButton.dataset.facetGroup;
            this.hideFilteringHeader = currentButton.dataset.hideFilteringHeader;

            if (this.facetGroupName === 'Authors') {
                return this.loadAuthors(function () {
                    return _this.finalizeSetFacetGroup(currentButton, setFacetGroupCallback);
                });
            } else {
                var facetGroups = _store2.default.get().getState().facets.groups;
                this.currentFacetGroup = facetGroups.find(function (g) {
                    return g.name === _this.facetGroupName;
                });
                return this.finalizeSetFacetGroup(currentButton, setFacetGroupCallback);
            }
        }
    }, {
        key: "loadAuthors",
        value: function loadAuthors(loadAuthorsCallback) {
            var _this2 = this;

            var authorsSerializedKey = _storageProvider2.default.sharedKeys.authorsSerializedKey;
            this.currentFacetGroup = _storageProvider2.default.getValueSession(authorsSerializedKey);
            if (!this.currentFacetGroup) {
                var searchService = abp.services.api.search;
                searchService.getAuthorsSerialized().done(function (result) {
                    if (!!result && !result.message) {
                        _this2.currentFacetGroup = result;
                        _storageProvider2.default.setValueSession(authorsSerializedKey, _this2.currentFacetGroup);
                        return loadAuthorsCallback && typeof loadAuthorsCallback === 'function' ? loadAuthorsCallback() : false;
                    }
                    console.error('Error in getting authors serialized from server.', (result || { message: 'N/A' }).message);
                    return false;
                });
            } else return loadAuthorsCallback && typeof loadAuthorsCallback === 'function' ? loadAuthorsCallback() : false;
        }
    }, {
        key: "finalizeSetFacetGroup",
        value: function finalizeSetFacetGroup(currentButton, callback) {
            if (!this.facetGroupName || !this.currentFacetGroup) {
                console.error("There is no facetGroup for clicked button: " + currentButton);
                return false;
            }

            this.selectedItems[this.facetGroupName] = _common2.default.loadSelectedFiltersFromUrl(this.getFilterParamRegex());

            if (callback && typeof callback === 'function') callback();
            return true;
        }
    }, {
        key: "setFilteringLabel",
        value: function setFilteringLabel() {
            var filteringLabel = this.dialog.querySelector('.filtering-label .label-text');
            if (filteringLabel) {
                filteringLabel.textContent = this.currentFacetGroup.displayName;
            }
            var labelIcon = this.dialog.querySelector('#filteringHeaderLabelIcon');
            if (labelIcon) {
                labelIcon.className = "label-icon " + this.currentFacetGroup.name.toLowerCase();
            }
        }
    }, {
        key: "setUpUserFacetFiltering",
        value: function setUpUserFacetFiltering() {
            var _this3 = this;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.dialog.querySelectorAll('.filtering-first-letters')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var firstLetterArea = _step.value;

                    this.setupFirstLetters(firstLetterArea);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var filteringHeaderText = this.dialog.querySelector('#filteringHeaderText');
            filteringHeaderText.value = this.filterString;
            if (filteringHeaderText) {
                var currentInstance = this;
                filteringHeaderText.addEventListener('keyup', function (event) {
                    _this3.filterString = event.target.value.toLowerCase();
                    (currentInstance || _this3).fillFilteringBody();
                });
            }
        }
    }, {
        key: "fillFilteringBody",
        value: function fillFilteringBody() {
            var _this4 = this;

            var filteringBodyElementId = '#filteringBody';
            var filteringBody = this.dialog.querySelector(filteringBodyElementId);
            if (!filteringBody) {
                console.error("There is no element with Id: " + filteringBodyElementId);
                return;
            }
            filteringBody.innerHTML = '';

            var facetItemArray = _common2.default.sortByStringParam(this.getFilteredItems(), 'displayName');
            var itemAmountLimit = !this.filteringLetter ? this.maxFilterItemsLimit : 999999;

            var _loop = function _loop(i) {
                var facetItem = facetItemArray[i];
                var facetItemDiv = _common2.default.createElement('div', filteringBody);
                var selectedItem = _this4.selectedItems[_this4.facetGroupName];
                var facetValue = facetItem.value;
                var facetItemCheckbox = _common2.default.createElement('input', facetItemDiv, {
                    id: "facetFilter" + facetValue,
                    type: 'checkbox',
                    checked: selectedItem.some(function (s) {
                        return s === facetValue || s.toString() === facetValue.toString();
                    })
                });
                var facetItemLabel = _common2.default.createElement('label', facetItemDiv, {
                    for: facetItemCheckbox.id,
                    textContent: facetItem.displayName.trim(),
                    checkBox: facetItemCheckbox,
                    filterValue: facetValue
                });
                facetItemLabel.addEventListener('click', function (event) {
                    return _this4.popupFilterCheckedEvent(event, _this4);
                });
            };

            for (var i = 0; i < facetItemArray.length && i < itemAmountLimit; i++) {
                _loop(i);
            }
        }
    }, {
        key: "setupFirstLetters",
        value: function setupFirstLetters(firstLetterArea) {
            var _this5 = this;

            var filteringHeader = this.dialog.querySelector('.filtering-header-main');
            if (this.hideFilteringHeader && filteringHeader) {
                filteringHeader.style.visibility = 'hidden';
            } else {
                if (filteringHeader) filteringHeader.style.visibility = '';

                firstLetterArea.innerHTML = '';
                var firstLetters = [].concat((0, _toConsumableArray3.default)(new _set2.default(this.currentFacetGroup.items.filter(function (f) {
                    return !!f && !!f.displayName;
                }).map(function (fi) {
                    return fi.displayName.toUpperCase().trim().at(0);
                }))));
                firstLetters = firstLetters.sort(function (a, b) {
                    return a[0].localeCompare(b[0]);
                });

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    var _loop2 = function _loop2() {
                        var letter = _step2.value;

                        var letterButton = _common2.default.createElement('span', firstLetterArea, {
                            textContent: letter,
                            className: 'letter-button'
                        });
                        var currentInstance = _this5;
                        letterButton.addEventListener('click', function (event) {
                            return _this5.filterByLetter(event, currentInstance);
                        });
                    };

                    for (var _iterator2 = (0, _getIterator3.default)(firstLetters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        _loop2();
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }
    }, {
        key: "filterByLetter",
        value: function filterByLetter(event) {
            var element = event.target;
            var selectedLetterClass = 'filter-selected-letter';

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(element.parentElement.getElementsByClassName(selectedLetterClass)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var selLetter = _step3.value;

                    selLetter.classList.remove(selectedLetterClass);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var letter = element.textContent.toLowerCase();
            if (this.filteringLetter === letter) this.filteringLetter = '';else {
                this.filteringLetter = letter;
                element.classList.add(selectedLetterClass);
            }
            this.fillFilteringBody();
        }
    }, {
        key: "popupFilterCheckedEvent",
        value: function popupFilterCheckedEvent(event, instance) {
            var element = event.target;
            element.checkBox.checked = !element.checkBox.checked;
            var index = -1;

            if (element.checkBox.checked) {
                instance.selectedItems[instance.facetGroupName].push(element.filterValue);
            } else if ((index = instance.selectedItems[instance.facetGroupName].indexOf(element.filterValue.toString())) > -1) {
                instance.selectedItems[instance.facetGroupName].splice(index, 1);
            }
        }
    }, {
        key: "getFilteredItems",
        value: function getFilteredItems() {
            var _this6 = this;

            var filteredItems = [];

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this.currentFacetGroup.items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var item = _step4.value;

                    var name = item.displayName.trim().toLowerCase();
                    if (name && !/^\s*$/.test(name) && (!this.filteringLetter || name.startsWith(this.filteringLetter)) && (!this.filterString || [].concat((0, _toConsumableArray3.default)(name.split(/\s+/))).some(function (n) {
                        return n.startsWith(_this6.filterString);
                    }))) filteredItems.push(item);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return filteredItems;
        }
    }, {
        key: "getFilterParamRegex",
        value: function getFilterParamRegex(facetName) {
            if (!facetName) facetName = this.facetGroupName;
            return _common2.default.getFilterParamRegex(facetName);
        }
    }, {
        key: "setDialog",
        value: function setDialog(dialog) {
            this.dialog = dialog;
        }
    }]);
    return FacetPopupFilter;
}();

exports.default = FacetPopupFilter;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/facetPopupFilter.js
// module id = 959
// module chunks = 0